// extracted by mini-css-extract-plugin
export var avatarContainer = "_8q-0";
export var avatarTypingWave = "_8q-i";
export var gray = "_8q-f";
export var green = "_8q-c";
export var icon = "_8q-9";
export var image = "_8q-1";
export var lg = "_8q-6";
export var md = "_8q-5";
export var presenceDot = "_8q-b";
export var red = "_8q-d";
export var sm = "_8q-4";
export var status = "_8q-a";
export var typingDot = "_8q-h";
export var typingPill = "_8q-g";
export var xl = "_8q-7";
export var xs = "_8q-3";
export var xxl = "_8q-8";
export var xxs = "_8q-2";
export var yellow = "_8q-e";